export default "__VITE_PUBLIC_ASSET__4c0eefcc__"